import "../../assets/css/SalesBill.css";
import ApiUrl from "./../Environment/ApiUrl";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Bill.css";

function OrderBigBill() {
  const { order_no } = useParams();
  const [ordersData, setOrdersData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // hook called inside component
  useEffect(() => {
    if (order_no) {
      fetchOrdersData();
    }
  }, [order_no]);

  const fetchOrdersData = async () => {
    try {
      setLoading(true);
      console.log("Fetching for order_no:", order_no);

      const response = await axios.get(
        `${ApiUrl}/Api/orders.php?order_no=${order_no}`
      );

      console.log("API response:", response.data);

      const filteredData = response.data.data?.find(
        (item) => item.order_no === order_no
      );
      console.log("Filtered data:", filteredData);

      if (filteredData) {
        setOrdersData(filteredData);
      } else {
        setError(`No sales data found for sales number: ${order_no}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError("Failed to fetch sales data");
    } finally {
      setLoading(false);
    }
  };

  // Format date from YYYY-MM-DD to DD-MMM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-US", options);
  };

  // ✅ CORRECTED numberToWords function - handles Rupees and Paise properly
  const numberToWords = (num) => {
    if (isNaN(num) || num === null || num === undefined) return "";
    if (num === 0) return "Zero Rupees Only";

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const numToWord = (n) => {
      if (n === 0) return "";
      if (n < 20) return ones[n];
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
      if (n < 1000)
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " and " + numToWord(n % 100) : "")
        );
      if (n < 100000)
        return (
          numToWord(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + numToWord(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          numToWord(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + numToWord(n % 100000) : "")
        );
      return (
        numToWord(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + numToWord(n % 10000000) : "")
      );
    };

    const decimalToWord = (decimalPart) => {
      if (decimalPart === 0) return "";
      const decStr = decimalPart.toString().padEnd(2, "0").slice(0, 2);
      const decValue = parseInt(decStr);

      if (decValue === 0) return "";

      // For Rupees, decimal represents paise
      if (decValue < 20)
        return " and " + ones[decValue] + " Paise";
      return (
        " and " +
        tens[Math.floor(decValue / 10)] +
        (decValue % 10 ? " " + ones[decValue % 10] : "") +
        " Paise"
      );
    };

    const parts = num.toString().split(".");
    const integerPart = parseInt(parts[0]) || 0;
    const decimalPart = parts[1]
      ? parseInt(parts[1].padEnd(2, "0").slice(0, 2))
      : 0;

    let result = integerPart === 0 ? "Zero" : numToWord(integerPart);
    result += integerPart === 1 ? " Rupee" : " Rupees";
    
    if (decimalPart > 0) result += decimalToWord(decimalPart);
    
    return result + " Only";
  };

  // Calculate totals from item list
  const calculateTotals = () => {
    if (!ordersData?.order_items)
      return {
        totalQty: 0,
        totalWeight: 0,
        totalAmount: 0,
        totalMaking: 0,
        totalWastage: 0,
      };

    return ordersData.order_items.reduce(
      (acc, item) => {
        acc.totalQty += parseInt(item.quantity) || 0;
        acc.totalWeight += parseFloat(item.weight) || 0;
        acc.totalAmount += parseFloat(item.amount) || 0;
        acc.totalMaking += parseFloat(item.making_charge) || 0;
        acc.totalWastage += parseFloat(item.making_wastage) || 0;
        return acc;
      },
      { totalQty: 0, totalWeight: 0, totalAmount: 0, totalMaking: 0, totalWastage: 0 }
    );
  };

  if (loading) return <div>Loading sales data...</div>;
  if (error) return <div>{error}</div>;
  if (!ordersData) return <div>No sales data available</div>;

  const { totalQty, totalWeight, totalAmount, totalMaking, totalWastage } = calculateTotals();
  const formattedDate = formatDate(ordersData.order_date);
  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  // Get the total amount for words conversion
  const totalAmountValue = parseFloat(ordersData.total) || 0;

  return (
    <div className="bill-container">
      {/* Print Button (visible only on screen) */}
      <button className="print-btn no-print" onClick={() => window.print()}>
        Print Bill
      </button>

      <button
        className="cancel-btn no-print"
        onClick={() => navigate("/orders")}
      >
        Cancel
      </button>
      {/* Header Section */}
      <div className="header-section d-flex justify-content-between align-items-center">
        {/* Left: Logo */}
        <div className="logo-container">
          <img
            src={require("../../assets/images/Final logo c.png")}
            alt="TIRUPUR Logo"
            className="logo"
            style={{ width: "100px" }}
          />
        </div>

        {/* Center: Company Info */}
        <div className="company-info text-center">
          <h4 className="mb-1">TIRUPUR JEWELLERY</h4>
          <p className="mb-0">
            3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002
          </p>
        </div>

        {/* Right: Invoice */}
        <div className="invoice-title">
          <p className="m-0 fw-bold">ORDER ESTIMATE</p>
        </div>
      </div>

      <hr className="divider" />

      {/* Invoice Details Section */}
      <div className="details-section">
        <div className="customer-info">
          <div className="customer-details">
            <p>{ordersData.customer_info.name}</p>
            <p>{ordersData.customer_info.address}</p>
            <p>Cell: {ordersData.customer_info.mobile}</p>
            <p>Recipient GST: N/A</p>
          </div>
        </div>
        <div className="invoice-info">
          <div className="info-row">
            <span>Date</span>
            <span>
              : {formattedDate}/{currentTime}
            </span>
          </div>
          <div className="info-row">
            <span>Order No</span>
            <span>: {ordersData.order_no}</span>
          </div>
          <div className="info-row">
            <span>Delivery Date</span>
            <span>: {ordersData.delivery_date}</span>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="table-section">
        <table className="bill-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Product</th>
              <th>Qty</th>
              <th>Weight(g)</th>
              <th>Rate</th>
              <th>Making Cost</th>
              <th>Wastage</th>
              <th>GST</th>
              <th>Amount</th>
            </tr>
          </thead>

          <tbody>
            {ordersData.order_items?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  {item.product}
                  {item.category ? ` (${item.category})` : ""}
                </td>
                <td>{item.quantity}</td>
                <td>{parseFloat(item.weight || 0).toFixed(3)}</td>
                <td>{parseFloat(item.rate || 0).toFixed(2)}</td>
                <td>{parseFloat(item.making_charge || 0).toFixed(3)}</td>
                <td>{parseFloat(item.making_wastage || 0).toFixed(3)}</td>
                <td>-</td>
                <td>{parseFloat(item.amount || 0).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="table-footer">
              <th colSpan="2">Total</th>
              <th>{totalQty}</th>
              <th>{totalWeight.toFixed(3)}</th>
              <th>-</th>
              <th>{totalMaking.toFixed(3)}</th>
              <th>{totalWastage.toFixed(3)}</th>
              <th>-</th>
              <th>{totalAmount.toFixed(2)}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="details-section">
        <div className="customer-info">
          <div className="amount-in-words">
            <p><strong>Amount in Words:</strong> {numberToWords(totalAmountValue)}</p>
          </div>
          <p>*Terms & Conditions</p>
          <p className="paragraph-cont">
            All jewellery items sold by TIRUPUR JEWELLERY are guaranteed to be
            genuine and accurately metal purity and gemstone specifications.
          </p>
        </div>
        <div className="invoice-info">
          <div className="totals-section">
            <div className="totals-grid">
              <div className="total-row highlight">
                <span>Net Total</span>
                <span>₹{totalAmountValue.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Payment Type</span>
                <span>
                  {ordersData.payment_history?.[0]?.payment_type || "N/A"}
                </span>
              </div>
              <div className="total-row">
                <span>Paid</span>
                <span>₹{parseFloat(ordersData.paid || 0).toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Balance</span>
                <span>₹{parseFloat(ordersData.balance || 0).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="divider" />

      {/* Footer Section */}
      <div className="footer-section">
        <div className="signatures">
          <div className="customer-sign">
            <p>Signature of the Customer</p>
          </div>

          <div className="">
            <p className="footer-notes">--- Thank You Visit Again ---</p>
            <div className="alaan">
              <p>Developed by Aalan Tech Soft - Salem</p>
            </div>
          </div>

          <div className="company-sign">
            <p>FOR TIRUPUR JEWELLERY </p>
            <p>Authorized Signature</p>
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .bill-container, .bill-container * {
            visibility: visible;
          }
          .bill-container {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            margin: 0;
            padding: 0;
          }
          .no-print {
            display: none !important;
          }
          @page {
            size: A5;
            margin: 0.5cm;
          }
        }
        
        .amount-in-words {
          font-size: 9px;
          margin-bottom: 10px;
          word-break: break-word;
        }
        
        .amount-in-words p {
          margin: 0;
        }
      `}</style>
    </div>
  );
}

export default OrderBigBill;